import { render, staticRenderFns } from "./TemplatesSettings_Pickup.vue?vue&type=template&id=6e74bec6"
import script from "./TemplatesSettings_Pickup.vue?vue&type=script&lang=js"
export * from "./TemplatesSettings_Pickup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports